 
const log = require('log').create('html_tokenizer', 'browser') // eslint-disable-line

// DOM-based tokenizer
//
// converts an html string into an array of tokens matching the DOM NodeList spec
// e.g.
// <p>A single paragraph.</p>
//     becomes =>
// [{
//     "nodeType": 1,
//     "tagName": "p",
//     "attributes": [],
//     "childNodes": [{
//         "nodeType": 3,
//         "data": "A single paragraph."
//     }]
// }]
//
// This tokenizer requires a DOM and should only be used in a browser.

function arrayFrom(arr) {
    return Array.prototype.slice.call(arr)
}

function tokenizeNodes(nodeList) {
    return arrayFrom(nodeList).map(tokenizeNode)
}

function tokenizeNode(node) {
    switch (node.nodeType) {
        case Node.TEXT_NODE:
            return tokenizeTextNode(node)
        case Node.ELEMENT_NODE:
            return tokenizeElementNode(node)
        default:
            return {
                nodeType: node.nodeType,
            }
    }
}

function tokenizeElementNode(node) {
    return {
        nodeType: node.nodeType,
        tagName: getTagName(node),
        attributes: tokenizeNodeAttributes(node),
        childNodes: tokenizeNodes(node.childNodes),
    }
}

function getTagName(node) {
    if (node.attributes) {
        const neutered = (
            arrayFrom(node.attributes)
                .filter(attr => attr.name === 'data-neutered')
                .map(attr => attr.value.toUpperCase())
        )[0]
        if (neutered) return neutered
    }
    return node.tagName.toUpperCase()
}

function tokenizeNodeAttributes(node) {
    return (
        arrayFrom(node.attributes)
            .filter(attr => attr.name !== 'data-neutered')
            .map(tokenizeAttribute)
    )
}

function tokenizeAttribute(attribute) {
    return {
        name: attribute.name,
        value: encodeEntities(attribute.value),
    }
}

function encodeEntities(html) {
    const d = document.createElement('div')
    d.appendChild(document.createTextNode(html))
    return d.innerHTML
}

function tokenizeTextNode(node) {
    return {
        nodeType: node.nodeType,
        data: getTextNodeHtml(node),
    }
}

function getTextNodeHtml(node) {
    const d = document.createElement('div')
    d.appendChild(node)
    return d.innerHTML
}

const neutered_wrapper = [
    'script',
    'object',
    'iframe',
    'audio',
    'video',
]
const neutered_singles = [
    'embed',
    'img',
]
const re_neutered_wrapper = new RegExp(`(<\\s*/?)(${neutered_wrapper.join('|')})([^>]*>)`, 'gim')
const re_neutered_singles = new RegExp(`(<\\s*/?)(${neutered_singles.join('|')})([^>]*>)`, 'gim')

function neuterHtml(html) {
    const str = (
        html
            .replace(re_neutered_wrapper, '$1div data-neutered="$2"$3')
            .replace(re_neutered_singles, '$1br data-neutered="$2"$3')
    )
    return str
}

function tokenize(html) {
    const str = neuterHtml(html)
    // console.log(`in  ${html}`)
    // console.log(`out ${str}`)
    const node = document.createElement('body')
    node.innerHTML = str
    return tokenizeNodes(node.childNodes)
}

module.exports = tokenize
module.exports.tokenizeNodes = tokenizeNodes
